<template>
  <div class="reschedule_wrap">
    <div class='res_container'>
      <div class="res_head">
        <h1>Reschedule
          <span @click='close'></span>
        </h1>
      </div>
      <div class="date_list" v-show="datasFn">
        <dl class="timeZone clearfix">
          <dt>
            <el-select v-model="time_zone" filterable placeholder="Time zone＊">
              <el-option v-for="(key, val) in timeZone" :label="val" :value="key" :key="val">
              </el-option>
            </el-select>
          </dt>
          <dd>The interview times listed below are presented </br> according to the time zone you selected</dd>
        </dl>

        <div class="choose_time">
          <div class="left">
            <!-- <p>{{calendar.items.text}}</p>  -->
            <Calendar :show="calendar.show" :type="calendar.items.type" :value="calendar.items.value" :x="calendar.x" :y="calendar.y" :begin="calendar.items.begin" @cancel="dateCancel" @ok="dateOk" :end="calendar.items.end" :sep="calendar.items.sep" :single="calendar.items.single" :rangeValue='calendar.items.rangeValue' :autoclose='calendar.items.autoclose'>
            </Calendar>
          </div>
          <div class="right">
            <ul class="clearfix" v-show='dayOne'>
              <li v-for='(item, index) in allow_time' :key="index" :class="{active:item.isActive, disable: isTimeDisable(item)}" @click="choseFn(index, isTimeDisable(item))">{{item.name}}</li>
            </ul>
            <p class="no_dates" v-show='!dayOne'>No available times that day, please check other dates.</p>
          </div>
        </div>
        <a href="javascript:;" class="submit" @click="submitFn">Submit</a>
      </div>
      <p class="no_dates" v-show="!datasFn">Currently there are no available times. You may check our schedule availability again tomorrow, or contact your interviewer for help.</p>
    </div>
    <div class="shadow_pop" :style="{height:window_size.height+'px',width:window_size.width+'px'}"></div>
  </div>
</template>
<script>
import Calendar from '@common/Calendar'

export default {
  props: [
    'timeZone',
    'interviewerId',
    'sureHandler',
    'scheduledTimeZone',
    'scheduledInterviewerDate'
  ],
  data() {
    return {
      calendar: {
        show: true,
        x: 0,
        y: 0,
        items: {
          type: 'date',
          begin: '', // "2015-08-20"
          end: '',
          value: '',
          text: '',
          sep: '-',
          single: true,
          autoclose: true,
          weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          months: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
          ]
        }
      },
      time_zone: '', //时区
      allow_time: [], //时间段
      datas: '',
      datasFn: true,
      dayOne: true,
      start_time: '',
      time_slot: {
        morning: [],
        afternoon: [],
        evening: []
      },
      book_cycles: '', //可选天数
      select_time: '', //获取当前点击的时间段,
      staff_id: '',
      after_second: ''
    }
  },
  created: function() {
    //以下为了解决日历插件在watch的时候获取不到时间的问题，所以在创建的时候就给它赋值
    //获取应聘者当前时间的秒数
    let time = new Date().getTime()
    let second = parseInt(time / 1000)
    this.start_time = second
    this.$http
      .get(
        '/interview/getInterViewTime?start_time=' +
          this.start_time +
          '&is_first=1'
      )
      .then(
        function(response) {
          if (response.data.code == '75000') {
            this.datas = response.data.res //保存返回数据
            //标记未来几天是否可约
            if (this.datas.is_book) {
              this.book_cycles = this.datas.book_cycles //可约时间段
              //计算可约时间段的最后一天
              let secondTime = (this.book_cycles * 1 - 1) * 24 * 60 * 60 * 1000 //获取可选天数毫秒数
              let start_day = new Date(this.datas.book_start_date).getTime()
              let endTime = new Date(start_day + secondTime)
              let year = endTime.getFullYear()
              let months =
                endTime.getMonth() + 1 < 10
                  ? '0' + (endTime.getMonth() + 1)
                  : endTime.getMonth() + 1
              let day =
                endTime.getDate() < 10
                  ? '0' + endTime.getDate()
                  : endTime.getDate()
              this.calendar.items.end = year + '-' + months + '-' + day //结束日期
              this.calendar.show = false
              this.calendar.show = true
              //渲染日历表的起始时间和当前时间
              this.calendar.items.begin = this.datas.book_start_date
              this.calendar.items.value = this.datas.book_selected_date
              this.calendar.items.text = this.datas.book_selected_date
            } else if (this.datas.is_book == false) {
              //显示无可约时间提示
              this.datasFn = false
            }
          }
        },
        function() {
          console.log('service error')
        }
      )
    //以上为了解决日历插件在watch的时候获取不到时间的问题，所以在创建的时候就给它赋值

    this.$watch(
      function() {
        //点击reschedule的时候请求时间接口
        return this.is_request
      },
      function(o, n) {
        if (this.is_request) {
          this.staff_id = this.interviewerId
          //获取应聘者当前时间的秒数
          let time = new Date().getTime()
          let second = parseInt(time / 1000)
          this.start_time = second
          this.$http
            .get(
              '/interview/getInterViewTime?start_time=' +
                this.start_time +
                '&is_first=1&staff_id=' +
                this.staff_id
            )
            .then(
              function(response) {
                if (response.data.code == '75000') {
                  this.datas = response.data.res //保存返回数据
                  //标记未来几天是否可约
                  if (this.datas.is_book) {
                    this.after_second = this.datas.after_second
                    this.book_cycles = this.datas.book_cycles //可约时间段

                    this.calendar.show = false
                    this.calendar.show = true

                    this.time_zone = this.datas.selected_time_zone //时区赋值
                  } else if (this.datas.is_book == false) {
                    //显示无可约时间提示
                    this.datasFn = false
                  }
                }
              },
              function() {
                console.log('service error')
              }
            )
        }
      }
    )

    this.$watch(
      function() {
        //监听时区的改变
        return this.time_zone
      },
      function(o, n) {
        //获取应聘者当前时间的秒数
        let time = new Date().getTime()
        let second = parseInt(time / 1000)
        this.start_time = second

        this.$http
          .get(
            '/interview/getInterViewTime?start_time=' +
              this.start_time +
              '&is_first=1&time_zone=' +
              this.time_zone +
              '&staff_id=' +
              this.staff_id
          )
          .then(
            function(response) {
              if (response.data.code == '75000') {
                this.datas = response.data.res //保存返回数据
                //标记未来几天是否可约
                if (this.datas.is_book) {
                  console.log(this.datas.is_book)

                  // this.time_zone = this.datas.selected_time_zone;//时区赋值
                  this.book_cycles = this.datas.book_cycles //可约时间段

                  //计算可约时间段的最后一天
                  let secondTime =
                    (this.book_cycles * 1 - 1) * 24 * 60 * 60 * 1000 //获取可选天数毫秒数
                  let start_day = new Date(this.datas.book_start_date).getTime()
                  let endTime = new Date(start_day + secondTime)
                  let year = endTime.getFullYear()
                  let months =
                    endTime.getMonth() + 1 < 10
                      ? '0' + (endTime.getMonth() + 1)
                      : endTime.getMonth() + 1
                  let day =
                    endTime.getDate() < 10
                      ? '0' + endTime.getDate()
                      : endTime.getDate()
                  this.calendar.items.end = year + '-' + months + '-' + day //结束日期

                  //渲染日历表的起始时间和当前时间
                  this.calendar.items.begin = this.datas.book_start_date
                  this.calendar.items.value = this.datas.book_selected_date
                  if (
                    this.calendar.items.text == this.datas.book_selected_date
                  ) {
                    this.select_time = ''
                    //获取应聘者当前时间的秒数
                    let time = new Date().getTime()
                    let second = parseInt(time / 1000)
                    this.start_time = second

                    let textAttr
                    let secondDate
                    let secondDates
                    //如果当前所选天数是可选时间的第一天
                    if (this.calendar.items.text == this.calendar.items.begin) {
                      //所传小时是当前小时
                      secondDates = this.start_time + this.after_second
                    } else {
                      //所传小时是零点
                      textAttr = new Date(this.calendar.items.text + ' 00:00')
                      secondDate = textAttr.getTime()
                      secondDates = parseInt(secondDate / 1000) //时间戳格式化到秒数
                    }

                    this.$http
                      .get(
                        '/interview/getInterViewTime?start_time=' +
                          secondDates +
                          '&time_zone=' +
                          this.time_zone +
                          '&is_first=0&staff_id=' +
                          this.staff_id +
                          '&selected_date=' +
                          this.calendar.items.text
                      )
                      .then(
                        function(response) {
                          if (response.data.code == '75000') {
                            this.datas = response.data.res //保存返回数据

                            //渲染时间段
                            this.allow_time = [] //每次请求清空时间段
                            if (this.datas.time_slot.length == 0) {
                              //判断如果所选日期没有可选时间段，提示无可选时间
                              this.dayOne = false
                            } else {
                              //所选日期有可选时间段

                              this.dayOne = true
                              function getArr(time_slot) {
                                //渲染可选时间段
                                var returnArr = []
                                var typeArr = [
                                  'morning',
                                  'afternoon',
                                  'evening'
                                ]
                                typeArr.forEach(function(item) {
                                  if (time_slot[item]) {
                                    for (
                                      let i = 0;
                                      i < time_slot[item].length;
                                      i++
                                    ) {
                                      returnArr.push({
                                        name: time_slot[item][i],
                                        isActive: false
                                      })
                                    }
                                  }
                                })
                                return returnArr
                              }
                              this.allow_time = getArr(this.datas.time_slot)
                            }
                          }
                        },
                        function() {
                          console.log('service error')
                        }
                      )
                  } else {
                    this.calendar.items.text = this.datas.book_selected_date
                  }
                  this.calendar.show = false
                  this.calendar.show = true
                } else if (this.datas.is_book == false) {
                  //显示无可约时间提示
                  this.datasFn = false
                }
              }
            },
            function() {
              console.log('service error')
            }
          )
      }
    )

    this.$watch(
      function() {
        //监听日期的改变
        return this.calendar.items.text
      },
      function(o, n) {
        this.select_time = ''
        //获取应聘者当前时间的秒数
        let time = new Date().getTime()
        let second = parseInt(time / 1000)
        this.start_time = second

        let textAttr
        let secondDate
        let secondDates
        //如果当前所选天数是可选时间的第一天
        if (this.calendar.items.text == this.calendar.items.begin) {
          //所传小时是当前小时
          secondDates = this.start_time + this.after_second
        } else {
          //所传小时是零点
          textAttr = new Date(this.calendar.items.text + ' 00:00')
          secondDate = textAttr.getTime()
          secondDates = parseInt(secondDate / 1000) //时间戳格式化到秒数
        }

        this.$http
          .get(
            '/interview/getInterViewTime?start_time=' +
              secondDates +
              '&time_zone=' +
              this.time_zone +
              '&is_first=0&staff_id=' +
              this.staff_id +
              '&selected_date=' +
              this.calendar.items.text
          )
          .then(
            function(response) {
              if (response.data.code == '75000') {
                this.datas = response.data.res //保存返回数据

                //渲染时间段
                this.allow_time = [] //每次请求清空时间段
                if (this.datas.time_slot.length == 0) {
                  //判断如果所选日期没有可选时间段，提示无可选时间
                  this.dayOne = false
                } else {
                  //所选日期有可选时间段

                  this.dayOne = true
                  function getArr(time_slot) {
                    //渲染可选时间段
                    var returnArr = []
                    var typeArr = ['morning', 'afternoon', 'evening']
                    typeArr.forEach(function(item) {
                      if (time_slot[item]) {
                        for (let i = 0; i < time_slot[item].length; i++) {
                          returnArr.push({
                            name: time_slot[item][i],
                            isActive: false
                          })
                        }
                      }
                    })
                    return returnArr
                  }
                  this.allow_time = getArr(this.datas.time_slot)
                }
              }
            },
            function() {
              console.log('service error')
            }
          )
      }
    )
  },
  methods: {
    isTimeDisable(time) {
      if (!this.scheduledTimeZone || !this.time_zone) return
      let scheduledTimeZone = this.timeZone[this.scheduledTimeZone]
      if (!scheduledTimeZone) return
      if (scheduledTimeZone != this.time_zone) return

      if (!this.scheduledInterviewerDate) return
      let [
        scheduled_date,
        scheduled_time
      ] = this.scheduledInterviewerDate.split(' ')
      return (
        scheduled_date === this.calendar.items.value &&
        scheduled_time
          .split(':')
          .slice(0, 2)
          .join(':') === time.name
      )
    },

    close() {
      this.$store.commit('reschedule_pop_show')
    },
    // 打开显示选择器
    open(e, type) {
      // 设置类型
      this.calendar.show = true
      this.calendar.x = e.target.offsetLeft
      this.calendar.y = e.target.offsetTop + e.target.offsetHeight + 8
    },
    dateCancel(obj) {
      this.calendar.show = obj.show
    },
    dateOk(obj) {
      this.calendar.items.text = obj.values[0]
      this.calendar.items.value = obj.values[0]
    },
    addZero: num => {
      num < 10 ? '0' + num : num
    },
    choseFn: function(index, disable) {
      if (disable) return

      //时间段点击
      for (let i = 0; i < this.allow_time.length; i++) {
        this.allow_time[i].isActive = false
      }
      this.allow_time[index].isActive = !this.allow_time[index].isActive
      this.select_time = this.allow_time[index].name
      console.log(this.select_time, this.allow_time[index].isActive)
    },
    async submitFn() {
      //点击提交

      if (this.select_time == '') {
        //如果没有选择时间段提示
        this.$message.error('Please choose the interview time!')
        return
      }
      
      let sureHandlerRes
      let isRemark

      if (this.sureHandler) {
        isRemark = this.$store.state.loginStatus.exact_status !== "canceled"
        sureHandlerRes = await this.sureHandler({
          type: 'reschedule',
          isRemark
        })
      }

      //选择的日期和时间段
      let interview_time = this.calendar.items.value + ' ' + this.select_time

      this.$http
        .get(
          '/interview/reschedule' +
            '?interview_time=' +
            interview_time +
            '&time_zone=' +
            this.time_zone +
            '&type=R' +
            (isRemark ?  '&remark=' + sureHandlerRes.remark : '')
        )
        .then(
          function(d) {
            if ((d.data.res = 75000)) {
              //成功之后刷新页面
              window.location.reload()
            }
          },
          function() {
            console.log('error')
          }
        )
    }
  },
  computed: {
    window_size() {
      return {
        width: window.outerWidth,
        height: window.outerHeight
      }
    },
    disableDate: function() {
      '' +
        addZero(new Date().getFullYear()) +
        '-' +
        addZero(new Date().getMonth() + 1) +
        '-' +
        addZero(new Date().getDate())
    },
    is_request() {
      return this.$store.state.pop_up
    }
  },
  components: {
    Calendar
  }
}
</script>
<style lang='less' scoped>
.reschedule_wrap {
  position: absolute;
  left: 0;
  top: 0;
  .res_container {
    position: fixed;
    left: 50%;
    top: 50%;
    width: 736px;
    height: 588px;
    transform: translate(-50%, -50%);
    z-index: 3;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
    .timeZone {
      height: 40px;
      margin: 25px 0 20px;
      dt {
        float: left;
        width: 338px;
      }
      dd {
        margin-left: 344px;
        line-height: 18px;
        font-size: 14px;
        padding-top: 2px;
      }
    }
    .res_head {
      height: 46px;
      line-height: 46px;
      background: #525252;
      & > h1 {
        position: relative;
        padding-left: 26px;
        font-size: 18px;
        color: #ffffff;
        span {
          position: absolute;
          right: 26px;
          top: 16px;
          width: 14px;
          height: 13px;
          background: url('~@img/close.png') no-repeat 0 0;
          cursor: pointer;
        }
      }
    }

    .choose_time {
      height: 374px;
      & > div {
        float: left;
        width: 50%;
        height: 100%;
      }
      .left {
      }
      .right {
        padding-top: 25px;
        height: 317px;
        overflow-y: auto;
        ul {
          li {
            float: left;
            width: 129px;
            height: 42px;
            background: #fff;
            box-sizing: border-box;
            border: 1px solid #fcc800;
            color: #ffb400;
            border-radius: 10px;
            text-align: center;
            line-height: 42px;
            font-size: 13px;
            margin: 0 25px 25px 0;
            cursor: pointer;
            &.active {
              background: #fcc800;
              color: #000;
            }
            &.disable {
              color: #a9a9a9;
              border-color: #ccc;
              cursor: not-allowed;
            }
          }
          li:nth-child(odd) {
            margin-left: 21px;
          }
        }
      }
    }
    a.submit {
      width: 129px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      border: none;
      border-radius: 10px;
      font-size: 14px;
      color: #1e1e1e;
      background-color: #fcc800;
      display: inline-block;
      margin: 20px 0 0 578px;
    }
    .no_dates {
      padding: 80px 50px 0px;
      line-height: 30px;
      text-indent: 20px;
    }
  }
  .shadow_pop {
    position: fixed;
    left: 0;
    top: 0;
    background: #000;
    opacity: 0.5;
    filter: alpha(opacity=50);
    z-index: 2;
  }
  .res_container {
    .el-select {
      width: 300px;
      margin: 0;
      margin-left: 25px;
    }
  }
}
</style>
<style  lang='less'>
.res_container {
  .el-select {
    width: 292px;
    height: 40px;
    margin: 30px 0 25px 25px;
    .el-input {
      input {
      }
    }
  }
}
.calendar {
  padding: 0!Important;
  margin: 10px;
  margin-top: 150px!Important;
  margin-left: 25px;
  border: 1px solid #cccccc;
  border-radius: 10px 10px 0 0!Important;
  overflow: hidden;
  table {
    thead {
      td {
        color: #ffb400;
      }
    }
    td {
      font-size: 13px;
      span {
        width: 36px!Important;
        height: 36px!Important;
        line-height: 36px!Important;
        border-radius: 100%;
        &:hover {
          background: #fff9e5!Important;
          color: #000!Important;
        }
      }
    }
    td.selected {
      span {
        background: #fcc800;
        border-radius: 100%;
        &:hover {
          background: #fcc800;
        }
      }
    }
  }
}
.calendar:after {
  display: none;
}
.calendar:before {
  display: none;
}
.calendar td.selected span:hover {
}
div.calendar-tools {
  height: 43px;
  line-height: 43px;
  background: #525252;
  i.glyphicon-menu-left,
  i.glyphicon-menu-right {
    margin: 0 25px;
  }
  i.glyphicon-menu-left:before,
  i.glyphicon-menu-right:before {
    color: #fff;
    font-size: 14px;
  }
  & > div {
    color: #fff;
    font-size: 18px;
    cursor: normal;
  }
}
</style>


// WEBPACK FOOTER //
// reschedule.vue?69e49582